import { Link } from "@tanstack/react-router";
import { Menu, Phone, X } from "lucide-react";
import { useState } from "react";

import logoSm from "@/assets/chavel-logo-236.webp.asset.json";
import logoMd from "@/assets/chavel-logo-472.webp.asset.json";

import { business } from "@/lib/business";
import { WhatsAppButton } from "./WhatsAppChat";

const nav = [
  { to: "/", label: "Início" },
  { to: "/servicos", label: "Serviços" },
  { to: "/$slug", params: { slug: "chaveiro-24-horas-betim" }, label: "24 horas" },
  { to: "/$slug", params: { slug: "chaveiro-automotivo-betim" }, label: "Automotivo" },
  { to: "/blog", label: "Blog" },
  { to: "/contato", label: "Contato" },
] as const;

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/95 backdrop-blur">
      <div className="bg-primary text-primary-foreground">
        <div className="container-page flex flex-wrap items-center justify-between gap-2 py-1.5 text-xs">
          <span>Chaveiro em Betim desde {business.since} • Atendimento 24 horas</span>
          <a href={`tel:${business.phoneRaw}`} className="inline-flex items-center gap-1 font-semibold">
            <Phone className="h-3.5 w-3.5" /> {business.phone}
          </a>
        </div>
      </div>

      <div className="container-page relative flex items-center justify-center gap-4 py-3 lg:justify-between">
        <Link to="/" className="flex items-center gap-2" aria-label="Chavel Chaveiro Betim - página inicial">
          <img
            src={logoSm.url}
            srcSet={`${logoSm.url} 236w, ${logoMd.url} 472w`}
            sizes="(min-width: 1024px) 148px, (min-width: 768px) 132px, 118px"
            alt="Chavel Chaveiro Betim, desde 1975"
            className="h-16 w-auto md:h-18 lg:h-20"
            width={236}
            height={129}
            fetchPriority="high"
            decoding="async"
          />

        </Link>

        <nav aria-label="Menu principal" className="hidden items-center gap-5 lg:flex">
          {nav.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              {...("params" in item ? { params: item.params } : {})}
              className="text-sm font-medium text-foreground/80 transition-colors hover:text-primary"
              activeProps={{ className: "text-primary font-semibold" }}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:block">
          <WhatsAppButton>Chamar agora</WhatsAppButton>
        </div>

        <button
          type="button"
          className="absolute right-4 top-1/2 -translate-y-1/2 lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Fechar menu" : "Abrir menu"}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open ? (
        <nav aria-label="Menu mobile" className="border-t border-border bg-background px-5 py-3 lg:hidden">
          <ul className="space-y-2">
            {nav.map((item) => (
              <li key={item.label}>
                <Link to={item.to} {...("params" in item ? { params: item.params } : {})} onClick={() => setOpen(false)} className="block py-1.5 text-sm font-medium">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="pt-3">
            <WhatsAppButton className="w-full">Chamar no WhatsApp</WhatsAppButton>
          </div>
        </nav>
      ) : null}
    </header>
  );
}
